import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { KitchenPricePdp } from 'landings';
import { RemoteProps } from './widgets-types';

export const KitchenPricePdpRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <KitchenPricePdp />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
